import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import Typewriter from 'typewriter-effect';
import p1 from '../photo_video/profile2.jpg'

function Profile() {
    return (
        <div>
            <div className='name m-0' id='home' >
                <div className='slider m-0'>
                    <Carousel className='sliderPhoto' controls={false}>
                        <Carousel.Item className='sliderPhoto p-md-4' interval={1500} style={{backgroundImage:'url(https://wallpapercave.com/wp/wp2733000.jpg)',backgroundSize:'cover'}}>
                            <div className='w-100 firstImg'>
                                <img
                                    className="carouselImg1"
                                    src={p1}
                                    alt="First slide"
                                    style={{ height: '100%', width: '100%',boxShadow:'0px 0px 53px -5px gray' }}
                                />
                            </div>
                        </Carousel.Item>
                        {/* <Carousel.Item className='sliderPhoto position-relative' interval={1500}>
                            <img
                                className="carouselImg"
                                src='https://cdn.wallpapersafari.com/75/27/W3CDPc.jpg'
                                alt="Second slide"
                                style={{ height: '100%', width: '100%' }}

                            />
                            <div className='position-absolute w-100 h-100 top-0' style={{backgroundColor:'black',opacity:'0.3'}}></div>
                        </Carousel.Item> */}
                    </Carousel>
                </div>
                <div className='position-absolute intro container' style={{zIndex:'2'}}>
                    <h4 className=' hello' style={{ margin: '0px', color: 'white' }}>Hello</h4>
                    <div className='d-flex'>
                        <div className=" profileName" style={{ margin: '0px', color: 'white', display: 'flex', }} ><span >I'am</span>
                            &nbsp;
                            <div>
                                <Typewriter
                                    options={{

                                        strings: ['Hepi Gadhesariya'],
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <h4 className=' hello mt-2' style={{ color: 'white' }}>Fitness & Wellness coach</h4>
                </div>
            </div>
            <div className='aboutMe row m-0'>
                {/* <div className='photo col-lg-5 container' style={{zIndex:'20'}}>
                    <div className='thumbnail'>
                        <Image src={photo} style={{ height: '100%', width: '100%' }} />
                    </div>
                </div> */}
                {/* <div className='col-lg-7 container'>
                    <div className='Tabs flex-column d-flex justify-content-center align-items-center'>
                        <div className='d-flex flex-column align-items-start container'>
                            <h1 style={{ textAlign: 'right' }}>About Me</h1>
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sed cumque, accusantium dolorum enim deleniti autem expedita iusto nulla aperiam temporibus molestiae ducimus veniam culpa iste harum! Harum ex autem reiciendis.</p>
                        </div>
                        <div className='Box' >
                            <Box sx={{ bgcolor: 'background.paper' }}>
                                <AppBar position="static">
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        variant="fullWidth"
                                        aria-label="full width tabs example"
                                    >
                                        <Tab label="Item One" {...a11yProps(0)} />
                                        <Tab label="Item Two" {...a11yProps(1)} />
                                        <Tab label="Item Three" {...a11yProps(2)} />
                                    </Tabs>
                                </AppBar>
                                <SwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                >
                                    <TabPanel value={value} index={0} dir={theme.direction}>
                                        <h3>Title</h3>
                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate magnam error ipsa dicta at porro placeat temporibus laudantium numquam iste voluptatibus nulla aspernatur, maxime minus corporis doloremque inventore repellat fugit.</p>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate magnam error ipsa dicta at porro placeat temporibus laudantium numquam iste voluptatibus nulla aspernatur, maxime minus corporis doloremque inventore repellat fugit.
                                        </p>
                                    </TabPanel>
                                    <TabPanel value={value} index={1} dir={theme.direction}>
                                        <h3>Title</h3>
                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate magnam error ipsa dicta at porro placeat temporibus laudantium numquam iste voluptatibus nulla aspernatur, maxime minus corporis doloremque inventore repellat fugit.</p>
                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate magnam error ipsa dicta at porro placeat temporibus laudantium numquam iste voluptatibus nulla aspernatur, maxime minus corporis doloremque inventore repellat fugit.</p>
                                    </TabPanel>
                                    <TabPanel value={value} index={2} dir={theme.direction}>
                                        <h3>Title</h3>
                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate magnam error ipsa dicta at porro placeat temporibus laudantium numquam iste voluptatibus nulla aspernatur, maxime minus corporis doloremque inventore repellat fugit.</p>
                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate magnam error ipsa dicta at porro placeat temporibus laudantium numquam iste voluptatibus nulla aspernatur, maxime minus corporis doloremque inventore repellat fugit.</p>
                                    </TabPanel>
                                </SwipeableViews>
                            </Box>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}


// function TabPanel(props) {
//     const { children, value, index, ...other } = props;

//     return (
//         <div
//             role="tabpanel"
//             hidden={value !== index}
//             id={`full-width-tabpanel-${index}`}
//             aria-labelledby={`full-width-tab-${index}`}
//             {...other}
//         >
//             {value === index && (
//                 <Box sx={{ p: 3 }}>
//                     <Typography>{children}</Typography>
//                 </Box>
//             )}
//         </div>
//     );
// }



export default Profile
